<script>
import Vue from "vue";
import VueApexCharts from "vue-apexcharts";

import { getVariant } from "../../helpers/badgeLookupTable";
import StackedChart from "./StackedChart.vue";
/*
  
  $data['eta'] = [
      'vencimiento_eta'   => Despacho::query()->vencimientoEta()->whereBetween('created_at', [$filtro, now()])->count(),
      'eta_vencida'       => Despacho::query()->etaVencida()->whereBetween('created_at', [$filtro, now()])->count(),
  ];

*/

Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);

export default {
  components: { StackedChart },
  props: {
    data: {
      type: Object,
      required: false,
    },
    irADespachosPendientes: Function,
    irADespachosRealizados: Function,
  },
  data() {
    return {
      chartOptions: {
        legend: {
          show: false,
        },
        chart: {
          width: 100,
          type: "donut",
        },
        dataLabels: {
          enabled: true,
        },
        labels: [],
        fill: {
          colors: ["#FFC72F", "#E65B38"],
        },
        responsive: [
          {
            breakpoint: 430,
            options: {
              chart: {
                width: 100,
              },
              legend: {
                show: false,
              },
            },
          },
        ],
      },
    };
  },
  computed: {
    series() {
      return Object.values(this.data ?? {});
    },
    parsedData() {
      return [
        {
          label: "ETA Por cumplir",
          value: this.data?.vencimiento_eta,
        },
        {
          label: "Vencido",
          value: this.data?.eta_vencida,
        },
      ];
    },
  },
  watch: {
    data: {
      immediate: true,
      handler(newVal) {
        const labels = this.parsedData.map((item) => item.label);

        this.chartOptions.labels = labels;
      },
    },
  },
  methods: {
    getVariant,
  },
};
</script>

<template>
  <div
    class="flex flex-col gap-2 h-full shadow-md bg-white border-primary border-[1px] p-4 w-full rounded-xl"
  >
    <!--
    <div class="mx-auto">
      <slot name="ver"></slot>
    </div>
    -->

    <h5 class="!text-left !font-bold">Fecha ETA</h5>

    <div class="flex flex-row gap-4 justify-between p-4 w-full">
      <div id="charts-eta" class="m-auto">
        <apexchart
          class="mx-auto"
          v-if="series && series.length > 0"
          type="donut"
          height="250"
          :options="chartOptions"
          :series="series"
        />
      </div>

      <div class="flex flex-col gap-4 w-[33%]">
        <div class="flex flex-row items-center gap-2 w-full">
          <div class="h-4 w-4 rounded-full aspect-square bg-[#FFC72F]"></div>
          <span
            class="cursor-pointer text-left"
            @click="
              irADespachosPendientes({
                estado: true,
                text: 'Estado Aforo',
                value: 'ETA por cumplir',
                filtro: 'vencimiento-eta',
              })
            "
          >
            ETA por cumplir
          </span>
        </div>

        <div class="flex flex-row text-let items-center gap-2 w-full">
          <div class="h-4 w-4 rounded-full aspect-square bg-[#E65B38]"></div>
          <span
            class="cursor-pointer text-left"
            @click="
              irADespachosRealizados({
                estado: true,
                text: 'Estado Aforo',
                value: 'Vencido',
                filtro: 'eta-vencida',
              })
            "
          >
            Vencido
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.arriba,
.vencido {
  cursor: pointer;
}
</style>
